import NatDisasterRepo from './repository/NatDisasterRepo';
import {Nullable} from '../../../app/TypeHelpers';
import * as React from 'react';
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet
} from '../../../components/shared/hoc/createResidentWithErrorHandlingPage';
import {ReactElement} from 'react';
import {PlainLinkStyledBackButton, StyledSecondaryButton} from '../../../styledComponents/Button';
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience';
import {DisplayItemDividerForPageTop} from '../../../styledComponents/DisplayItem';
import {StyledPageTitle} from '../../../components/reservations/components/CommonStyle';
import {
    HeadingAreaMessageComponentForResident
} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponentForResident';
import styled from 'styled-components';
import {Messages} from '../../../Messages';
import {NatPutDisasterTopicEditRequest} from './repository/NatPutDisasterTopicEdit';
import {NatBaseResponseInterface} from '../common/repository/NatBaseResponseInterface';
import {TopicInfo} from './repository/NatGetDisasterTopic';
import {NatPostDisasterTopicRegisterRequest} from './repository/NatPostDisasterTopicRegister';
import NatResidentDisasterTopicForm from './resident/NatResidentDisasterTopicForm';

interface Props {
    condominiumCd: string,
    topicId: number,
    disasterRepo: NatDisasterRepo,
}

interface State {
    isLoadCompleted: boolean,
    topicInfo: Nullable<TopicInfo>
}

class NatResidentDisasterTopicEditPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            isLoadCompleted: false,
            topicInfo: null,
        }

        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
        this.onClickRegisterButton = this.onClickRegisterButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const {disasterRepo, eventEmitter} = this.props
        await this.props.eventEmitter.showLoading();
        try {
            if (this.props.condominiumCd) {
                const disasterTopic = await this.props.asyncCallFunction(
                    disasterRepo.getDisasterTopicDetail.bind(
                        disasterRepo, this.props.condominiumCd, this.props.topicId
                    ),
                    (httpErrorOrNetworkError) => {
                        eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    }
                )
                this.setState({
                    topicInfo: disasterTopic?.details ?? null
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading();
            this.setState({
                isLoadCompleted: true
            })
        }
    }

    handleBackLinkOnClick(): void {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/disasters/topics/${this.props.topicId}`
        )
    }

    async onClickRegisterButton(requestParam: NatPostDisasterTopicRegisterRequest): Promise<void> {
        const {eventEmitter, disasterRepo, condominiumCd, topicId} = this.props
        const {topicInfo} = this.state
        await this.props.eventEmitter.showLoading()
        try {
            const request: NatPutDisasterTopicEditRequest = {
                category: requestParam.category,
                title: requestParam.title,
                description: requestParam.description,
                version: topicInfo?.version ?? 0
            }
            const response: Nullable<NatBaseResponseInterface> = await this.props.asyncCallFunction(
                this.props.disasterRepo.editDisasterTopicResident.bind(
                    disasterRepo, condominiumCd, topicId, request
                ),
                (httpErrorOrNetworkError) => {
                    httpErrorOrNetworkError.broadcast(eventEmitter)
                },
                {
                    defaultErrorTitle: Messages.EOPCR0014.toString(),
                    defaultErrorTitlePriority: true
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(`/resident/condominiums/${condominiumCd}/disasters/topics/${topicId}`)
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    render(): ReactElement {
        const {isLoadCompleted, topicInfo} = this.state
        if (!isLoadCompleted) {
            return (<></>)
        }
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>
                    戻る
                </PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <StyledPageTitle>トピック編集</StyledPageTitle>
                <BlockSpacer height={'20px'}/>
                <HeadingAreaMessageComponentForResident eventEmitter={this.props.eventEmitter}/>
                {topicInfo &&
                    <NatResidentDisasterTopicForm
                        {...this.props}
                        {...this.state}
                        topicInfo={topicInfo}
                        submitButtonLabel={'登録する'}
                        onClickRegisterButton={this.onClickRegisterButton}
                    />
                }
                <BackButton onClick={this.handleBackLinkOnClick}>
                    戻る
                </BackButton>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentDisasterTopicEditPage)

const BackButton = styled(StyledSecondaryButton)`
    margin-top: 30px;
    margin-bottom: 15px;
`